import { createFileRoute, redirect } from '@tanstack/react-router';
import { AppLayout } from '@/app/layouts/AppShell';
import { isAuthenticatedSync } from '@/shared/lib/auth-state';

export const Route = createFileRoute('/_app')({
  beforeLoad: ({ location }) => {
    if (!isAuthenticatedSync()) {
      throw redirect({
        to: '/login',
        search: { redirect: location.pathname },
      });
    }
  },
  component: AppLayout,
});
